/* eslint camelcase: 0 */
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import * as categoryApiCall from '../../../actionCreators/category';
import * as commonApiCall from '../../../actionCreators/common';
import { showGlobalHeaderFooter } from '../../../actionCreators/header';
import * as productApiCall from '../../../actionCreators/product';
import Customevent from '../../../utils/Customevent';
import { odPushGA4Event } from '../../../utils/gaFour';
import {
  calcGSTPrice,
  extractUtmSourceFromUrl,
  getHelplineNo,
  getQueryParam,
  roundUptoDigits,
} from '../../../utils/helper';
import localStorageHelper from '../../../utils/localStorageHelper';
import sessionStorageHelper from '../../../utils/sessionStorageHelper';
import { userProperties } from '../../../CommonComponents/UserPropertiesForGA/UserProperties';
import LeftContentNew from '../../components/Product/LeftContentNew';
import './Product.scss';
import SideBarOwnDays from '../../components/Product/SideBarOwnDays/SideBarOwnDays';
// return if needed
// import ProductAnalysisSection from '../../../own-days/Desktop/ProductAnalysisSection/ProductAnalysisSection';
// return if needed
// import PDPViewSwitcher from '../../../own-days/Desktop/Product/PDPViewSwitcher/PDPViewSwitcher';
import { odPushTTQEvent } from '../../../utils/tiktokPixel';
import apiClient from '../../../helpers/apiClient';
import { apiPath } from '../../../config';
import { getProductCurrency, getProductPrice } from '../../../own-days/helper';

import RecommendedList from '../../../own-days/CommonComponents/RecommendedList/RecommendedList';
import { odPushClevertapEvent } from '../../../utils/clevertap';
import { isAccessories } from './productHelper';
import Breadcrumb from '../../components/Common/Breadcrumb';

class Product extends PureComponent {
  static propTypes = {
    fetchLensPackages: PropTypes.any,
  };

  constructor(props, context) {
    super(props, context);
    this.state = {
      isContinueClickedInOfferModalSuccess: false,
      showPhnCapture: true,
      colorPreviewImageUrl: '',
      contactLensPowers: [],
      contactLensPackaging: '',
    };
    this.exchangePrice = {};
    this.showFAQTab = this.showFAQTab.bind(this);
    this.showTab = this.showTab.bind(this);
    this.dtmLoaded = true;
    this.dataLayerLoad = true;
    this.lenskartPriceWithGST = 0;
    this.handleScroll = this.handleScroll.bind(this);
    this.isYotpoRating = true;
    this.updateTryOnSwitch = this.updateTryOnSwitch.bind(this);
    this.triggerFbEventOnClick = this.triggerFbEventOnClick.bind(this);
    this.hideToolTip = this.hideToolTip.bind(this);
    this.handlePhnCaptureDesktop = this.handlePhnCaptureDesktop.bind(this);
    this.setColorPreviewImageUrl = this.setColorPreviewImageUrl.bind(this);
    this.isExchange =
      (sessionStorageHelper.getItem('exchangeMethod') === 'NEWPRODUCT' &&
        sessionStorageHelper.getItem('exchangeNP') === true) ||
      null;
  }

  componentDidMount() {
    const { redisCommonData, location, localeInfo, productApiCall } = this.props;
    const productData = this.props.productData && this.props.productData.result;

    if (this.isExchange && productData && productData.prices) {
      this.exchangePrice = productData.prices.find(
        price => price.name === 'Remaining Exchange Price'
      );
      if (this.exchangePrice) productApiCall.updateExchangeRemaining(this.exchangePrice.price);
      this.props.showGlobalHeaderFooter({ header: false });
    }

    if (productData?.id) {
      productApiCall.get360viewStatus(productData.id);
      this.getContactLensPowers();

      odPushGA4Event('page_view', {
        screenName: 'product-detail-page',
        userInfo: this.props.userInfo,
        platform: this.props.platform,
      });

      const gaPLPSelectItemData =
        JSON.parse(sessionStorage.getItem('ga-plp-select-item-data')) || {};

      odPushGA4Event('view_item', {
        userInfo: this.props.userInfo,
        productData,
        gaPLPSelectItemData,
      });

      odPushTTQEvent('ViewContent', {
        userInfo: this.props.userInfo,
        productData,
      });

      odPushClevertapEvent('Product Viewed', {
        productID: productData?.id,
        productName: productData?.fullName,
        category: productData?.classification,
        price: getProductPrice(productData),
        currency: getProductCurrency(productData),
        brand: productData?.brandName,
        variant: productData?.modelName,
        productURL: productData?.url,
        imageURL: productData?.thumbnailImage,
      });
    }
    window.scrollTo(0, 0);
    if (_gaq && productData) {
      _gaq.push(
        [
          '_setCustomVar',
          5,
          productData.qty !== 0 ? 'In Stock' : 'Out Of Stock',
          productData.sku,
          3,
        ],
        [
          '_trackEvent',
          'Product Page Details',
          productData.brandName,
          productData.sku,
          productData.prices[0].price,
          true,
        ],
        [
          'ninja._setCustomVar',
          5,
          productData.qty !== 0 ? 'In Stock' : 'Out Of Stock',
          productData.sku,
          3,
        ],
        [
          'ninja._trackEvent',
          'Product Page',
          productData.brandName,
          productData.sku,
          productData.prices[0].price,
          true,
        ]
      );
    }
    if (
      redisCommonData.RBI_POLICY_MARKETPLACE_CONFIG &&
      JSON.parse(redisCommonData.RBI_POLICY_MARKETPLACE_CONFIG).pdp === 'ON'
    ) {
      this.changeLenskartLogo(this.props);
    }

    if (this.dataLayerLoad && productData) {
      // dataLayer update
      let dataLayerData = {};
      let visitorProductName = productData.fullName;
      const query = location && location.search.substr(1);
      const isUrlHasPower = query.includes('power');
      const urlSource = query.includes('-shoppingads&');
      if (isUrlHasPower && urlSource) {
        const power = getQueryParam(query, 'power');
        const contactLensPowerFromUrl = power ? `Power: ${power}` : '';
        visitorProductName = visitorProductName + ' ' + contactLensPowerFromUrl;
      }
      const {
        utm_source = null,
        utm_medium = null,
        utm_campaign = null,
        utm_term = null,
        utm_content = null,
      } = extractUtmSourceFromUrl(this.props.location.search);

      if (utm_source || !localStorage.getItem('utmSource')) {
        localStorage.setItem(
          'utmSource',
          JSON.stringify({ utm_source, utm_medium, utm_campaign, utm_term, utm_content })
        );
      }

      const utmSource = JSON.parse(localStorage.getItem('utmSource'));
      dataLayerData = {
        event: 'VirtualPageView',
        PageUrl: window.location.href,
        visitorStore: window.location.host,
        visitorUtm_Source: utmSource.utm_source || '(direct)',
        visitorUtm_Cam: utmSource.utm_campaign || '(direct)',
        visitorUtm_Medium: utmSource.utm_medium || '(none)',
        isLoggedIn: this.props.login ? 1 : 0,
        visitorProductId: productData.id,
        visitorCategoryName: productData.brandName,
        visitorProductName,
        visitorProductSku: productData.sku,
        visitorProductValue:
          productData.prices[1] !== undefined || productData.prices[1] !== null
            ? productData.prices[1].price
            : '',
        visitorMarketValue:
          productData.prices[0] !== undefined || productData.prices[0] !== null
            ? productData.prices[0].price
            : '',
        EmailId:
          this.props.userInfo !== null && this.props.userInfo !== undefined
            ? this.props.userInfo.result.email
            : '',
        mobile:
          this.props.userInfo !== null &&
          this.props.userInfo?.result?.telephone !== undefined &&
          typeof window !== 'undefined' &&
          typeof window.btoa !== 'undefined'
            ? window.btoa(this.props.userInfo.result.telephone)
            : '',
        visitorPageType: 'ProductPage',
        // repeat for check if all goes ok then we have to remove repeatted one
        utmSource: utmSource.utm_source || '',
        utmCampaign: utmSource.utm_campaign || '',
        utmMedium: utmSource.utm_medium || '',
        utmTerm: utmSource.utm_term || '',
        utmContent: utmSource.utm_content || '',
        website_source: `${localeInfo.countryCode} headless`,
      };
      window.dataLayer.push(dataLayerData);
      this.dataLayerLoad = false;
    }

    if (this.dtmLoaded && productData) {
      const size = productData.frameDetails.find(key => {
        if (key.name === 'Size') {
          return key.value;
        }
        return false;
      });
      const gender =
        productData.specifications[0] &&
        productData.specifications[0].items.find(key => {
          if (key.name === 'Gender') {
            return key.value;
          }
          return false;
        });
      const lenskartPrice =
        productData.prices[1] && productData.prices[1].name === 'Lenskart Price'
          ? productData.prices[1].price
          : '';
      const ftype =
        productData.specifications[1] &&
        productData.specifications[1].items.find(key => {
          if (key.name === 'Frame Type') {
            return key.value;
          }
          return false;
        });
      const fshape =
        productData.specifications[1] &&
        productData.specifications[1].items.find(key => {
          if (key.name === 'Frame Shape') {
            return key.value.toLowerCase();
          }
          return false;
        });
      const cxid = this.props.userInfo === null ? '' : this.props.userInfo.result.id;
      const loginStatus = this.props.login ? 'loggedIn' : 'guest';
      if (this.props.fetchLensPackages.result.packages) {
        if (window.dtm.LenskartRewamp) {
          window.dtm.LenskartRewamp.allPage('pdp page');
          window.dtm.LenskartRewamp.Pdp.load.pdpPage(
            productData.type,
            cxid,
            typeof productData.subCategories !== 'undefined'
              ? productData.subCategories.replace(/-/g, '|').toLowerCase()
              : 'not available',
            productData.id,
            size && size.value,
            ftype && ftype.value,
            fshape && fshape.value,
            productData.brandName,
            gender ? gender.value : '',
            '',
            lenskartPrice,
            loginStatus
          );
          window.dtm.LenskartRewamp.Pdp.load.ecommproductDetailView(
            productData,
            lenskartPrice,
            loginStatus,
            'productDetailView'
          );
        }
      }

      window.clevertapScreenName = 'product-detail-page';
    }

    this.storeRecentViewProducts();
    const event = new Customevent('productDataLoaded');
    event.dispatch();
    this.refreshReviewWidget();
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('click', this.hideToolTip);

    (function (h, o, t, j, a, r) {
      h.hj =
        h.hj ||
        function () {
          (h.hj.q = h.hj.q || []).push(arguments);
        };
      h._hjSettings = { hjid: 3928241, hjsv: 6 };
      a = o.getElementsByTagName('head')[0];
      r = o.createElement('script');
      r.async = 1;
      r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
      a.appendChild(r);
      console.log('🚀 ~ Product ~ componentDidMount ~ Hotjar:', 'Hotjar');
    })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');
  }

  componentDidUpdate(prevProps) {
    const { userInfo, threeSixtyViewStatus } = this.props;
    const productPageVisited = localStorageHelper.getItem('productPageVisited');
    if (threeSixtyViewStatus && threeSixtyViewStatus.android_active === 1 && !productPageVisited) {
      document.body.style.pointerEvents = 'none';
    }
    const productData = this.props.productData && this.props.productData.result;
    if (productData && productData.id !== prevProps.productData.result.id) {
      window.scrollTo(0, 0);
      this.setGSTPrice();
      this.refreshReviewWidget();
      if (this.isExchange) {
        this.exchangePrice =
          productData.prices &&
          productData.prices.find(price => price.name === 'Remaining Exchange Price');
        if (this.exchangePrice) productApiCall.updateExchangeRemaining(this.exchangePrice.price);
      }

      if (
        productData?.classification === 'contact_lens' &&
        productData?.id &&
        !this.state.contactLensPowers?.length
      )
        this.getContactLensPowers();
    }
    if (prevProps.userInfo !== userInfo && userInfo) {
      const obj = window?.dataLayer.findIndex(o => o.event === 'VirtualPageView');
      if (obj) {
        if (window?.dataLayer?.[obj]?.mobile)
          window.dataLayer[obj].mobile =
            userInfo !== null &&
            userInfo !== undefined &&
            userInfo?.result?.telephone !== undefined &&
            typeof window !== 'undefined' &&
            typeof window.btoa !== 'undefined'
              ? window?.btoa(userInfo?.result?.telephone)
              : '';
      }
    }
    if (
      prevProps.userInfo !== userInfo &&
      userInfo?.result &&
      Object.keys(userInfo?.result).length > 0
    ) {
      userProperties(userInfo?.result, 'pdp-page', 'desktop', this.props.dataLocale);
    }
  }
  componentWillUnmount() {
    this.props.productApiCall.flushProductData();
    clearTimeout(this.yotpoRefreshTimeout);
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('click', this.hideToolTip);
  }
  setGSTPrice() {
    const { productData, modifiedProductData, redisCommonData } = this.props;
    const { lenskartPrice, frameType } = modifiedProductData;
    const productgst =
      redisCommonData && redisCommonData.PRODUCTS_GST
        ? JSON.parse(redisCommonData.PRODUCTS_GST)
        : {};
    const priceWithGst = calcGSTPrice(
      productData.result.classification,
      productData.result.brandName,
      frameType,
      lenskartPrice,
      productgst
    );
    this.lenskartPriceWithGST = roundUptoDigits(priceWithGst, 2);
  }

  getContactLensPowers() {
    const client = apiClient();
    client.setHeader();
    client
      .get(`${apiPath.dataProduct}${this.props.productData.result.id}/powers?contact_lens=`)
      .then(res => {
        if (Number(res?.status) === 200) {
          this.setState({
            contactLensPowers: res?.result?.powerTypeList || [],
            contactLensPackaging: res?.result?.contactPackaging?.split(' ')?.[0] || '',
          });
        }
      })
      .catch(() => {});
  }

  setColorPreviewImageUrl = colorPreviewImageUrl => {
    this.setState({ colorPreviewImageUrl });
  };

  showFAQTab() {
    if (this.props.productTabIndex === 4) {
      this.setState({ activefaqTab: !this.state.activefaqTab });
    } else {
      this.props.productApiCall.changeTabIndex(4);
      this.setState({ activefaqTab: !this.state.activefaqTab });
    }
  }

  showTab(val) {
    this.props.productApiCall.changeTabIndex(val);
    this.setState({ activefaqTab: false });
  }

  updateTryOnSwitch(flag) {
    const { commonApiCall, isTryOnSwitch, categoryApiCall } = this.props;
    if (flag !== undefined) {
      commonApiCall.updateTryOnSwitch({ isTryOnSwitch: flag });
      categoryApiCall.updateDittoEnable(flag);
      return;
    }
    if (isTryOnSwitch) {
      commonApiCall.updateTryOnSwitch({ isTryOnSwitch: false });
      categoryApiCall.updateDittoEnable(false);
    } else {
      if (window.dtm.LenskartRewamp) window.dtm.LenskartRewamp.Pdp.load.tryOnSwitchOnLoad();
      commonApiCall.updateTryOnSwitch({ isTryOnSwitch: true });
      categoryApiCall.updateDittoEnable(true);
    }
  }
  triggerFbEventOnClick = () => {
    const productData = this.props.productData && this.props.productData.result;
    const { classification, id, prices } = productData;
    const lenskartPrice = prices?.filter(p => p.name === 'Lenskart Price');
    window.ReactPixel.default.track('AddToWishlist', {
      content_type: 'product',
      content_ids: id,
      value: lenskartPrice[0]?.price,
      content_name: classification,
      currency: lenskartPrice[0]?.currencyCode,
    });
  };

  // Offer Modal : Continue button Clicked in success screen
  changeIsContinueClickedInOfferModalSuccess(val) {
    this.setState({
      isContinueClickedInOfferModalSuccess: val,
    });
  }

  handlePhnCaptureDesktop = () => {
    localStorageHelper.setItem('repeatFlowPhoneCapture', 'true');
    this.setState({
      showPhnCapture: !this.state.showPhnCapture,
    });
  };

  storeRecentViewProducts = () => {
    const { productData } = this.props;
    let productImageFront = null;

    const productId = productData.result && productData.result.id ? productData.result.id : null;
    const productImages =
      productData.result && productData.result.imageUrlsDetail
        ? productData.result.imageUrlsDetail
        : [];
    const productBrandName =
      productData.result && productData.result.brandName ? productData.result.brandName : null;
    const productUrl = productData.result && productData.result.url ? productData.result.url : null;
    const productPrices =
      productData.result && productData.result.prices ? productData.result.prices : [];
    const imageFrontObj = productImages.find(obj => obj.label === 'Image_Front');
    productImageFront = imageFrontObj ? imageFrontObj.url : productImages[0]?.url;

    const jsonData = [
      {
        id: productId,
        productUrl,
        imageUrl: productImageFront,
        prices: productPrices,
        brandName: productBrandName,
      },
    ];
    const recentViewProducts = localStorage.getItem('recentViewProducts')
      ? JSON.parse(localStorage.getItem('recentViewProducts'))
      : [];
    if (recentViewProducts.length >= 8) {
      recentViewProducts.pop();
    }
    const matchIndex = recentViewProducts.findIndex(obj => obj.id === productId);
    if (matchIndex !== -1) {
      recentViewProducts.splice(matchIndex, 1);
    }
    const copyJsonData = jsonData.concat(recentViewProducts);
    localStorage.setItem('recentViewProducts', JSON.stringify(copyJsonData));
  };

  changeLenskartLogo(props) {
    const { productData, commonApiCall } = props;
    if (
      !(
        productData.result.classification?.indexOf('eyeframe') > -1 ||
        productData.result.classification?.indexOf('loyalty_') > -1
      )
    ) {
      commonApiCall.changeLogo('dealskart');
    } else {
      commonApiCall.changeLogo('lenskart');
    }
  }

  refreshReviewWidget() {
    if (window && window.Yotpo && window.yotpo && window.yotpo.initialized) {
      const yotpoApi = new window.Yotpo.API(window.yotpo);
      if (yotpoApi) {
        this.yotpoRefreshTimeout = setTimeout(() => yotpoApi.refreshWidgets(), 1000);
      }
    }
  }

  handleScroll() {
    const scrollTop =
      window.pageYOffset !== undefined ? window.pageYOffset : document.documentElement.scrollTop;
    const yotpoReview = document.querySelector('.review-carousel')
      ? document.querySelector('.review-carousel').offsetTop
      : null;
    if (this.isYotpoRating && yotpoReview && scrollTop > yotpoReview) {
      this.refreshReviewWidget();
      this.isYotpoRating = false;
    }
  }

  hideToolTip() {
    document.body.style.pointerEvents = 'all';
  }

  render() {
    const { isContinueClickedInOfferModalSuccess } = this.state;
    const {
      localeInfo,
      setWishList,
      redisCommonData,
      location,
      productID,
      dataLocale,
      history,
      userInfo,
    } = this.props;
    const { PRODUCT_DATA_NOT_FOUND, PRODUCT_TYPE_OR_PRICE_MISSING } = dataLocale;
    const productData = this.props.productData && this.props.productData.result;
    if (!productData) {
      console.error(`${new Date()} : ${this.props.location.pathname} : ${PRODUCT_DATA_NOT_FOUND}`);
    } else if (!productData.type || !productData.prices) {
      console.error(
        `${new Date()} : ${this.props.location.pathname} : ${PRODUCT_TYPE_OR_PRICE_MISSING}`
      );
    }
    console.log('this is product description ====>', productData);
    const helplineNo = redisCommonData
      ? getHelplineNo(redisCommonData.MISSED_CALL_CONFIG, productData && productData.type)
      : '';
    const { firstFrameFree, firstFrameFreeDLPrice, frameType, frameShape, frameSize } =
      this.props.modifiedProductData;
    const lenskartPrice =
      productData.prices[1] && productData.prices[1].name === 'Lenskart Price'
        ? productData.prices[1].price
        : '';
    const query = location.search.substr(1);
    const power = getQueryParam(query, 'power');
    const contactLensPowerFromUrl = power ? `Power: ${power}` : '';
    const selectedPowerFromUrl = power || '';
    // Offer Modal : If user hasPlacedOrder is true It means repeatUser
    const isRepeatUser = Boolean(userInfo && userInfo.result && userInfo.result.hasPlacedOrder);
    const { PRODUCT_OFFERID_CONFIG_DESKTOP } = redisCommonData;
    const pdp_ipl =
      PRODUCT_OFFERID_CONFIG_DESKTOP &&
      PRODUCT_OFFERID_CONFIG_DESKTOP[productData.offerName] &&
      PRODUCT_OFFERID_CONFIG_DESKTOP[productData.offerName].pdp_ipl;

    const isAccessoriesFlagDesktop = isAccessories(productData);

    return (
      <>
        {productData?.breadcrumb && (
          <Breadcrumb
            breadcrumbData={productData?.breadcrumb}
            contactLensPowerFromUrl={contactLensPowerFromUrl}
            dataLocale={dataLocale}
            helplineNo={helplineNo}
            productID={productID}
          />
        )}
        <main className="product">
          <div className="product-container">
            {productData && [
              <div key="pdp-container" className="product-top">
                <div className="product-top__left">
                  <div className="product-top__left-actions"></div>
                  <LeftContentNew
                    {...this.props}
                    colorPreviewImageUrl={this.state.colorPreviewImageUrl}
                  />
                  <RecommendedList currentProductId={productData?.id} />
                </div>
                <SideBarOwnDays
                  {...this.props}
                  changeIsContinueClickedInOfferModalSuccess={val =>
                    this.changeIsContinueClickedInOfferModalSuccess(val)
                  }
                  contactLensPackaging={this.state.contactLensPackaging}
                  contactLensPowerFromUrl={contactLensPowerFromUrl}
                  contactLensPowers={this.state.contactLensPowers}
                  exchangePrice={this.exchangePrice}
                  frameShape={frameShape}
                  frameSize={frameSize}
                  frameType={frameType}
                  isContinueClickedInOfferModalSuccess={isContinueClickedInOfferModalSuccess}
                  isRepeatUser={isRepeatUser}
                  pdp_ipl={pdp_ipl}
                  productData={productData}
                  productId={productData.id}
                  productPriceWithGst={this.lenskartPriceWithGST}
                  redisCommonData={redisCommonData}
                  selectedPowerFromUrl={selectedPowerFromUrl}
                  setColorPreviewImageUrl={this.setColorPreviewImageUrl}
                  setWishList={setWishList}
                  showFAQTab={this.showFAQTab}
                  triggerFbEventOnClick={this.triggerFbEventOnClick}
                  updateTryOnSwitch={this.updateTryOnSwitch}
                />
              </div>,
            ]}
          </div>
        </main>
      </>
    );
  }
}
const mapStateToProps = state => ({
  redisCommonData: state.common.redisCommonData,
  isYotpoWidgets: state.common.isYotpoWidgets,
  modifiedProductData: state.product.modifiedProductData,
  location: state.router.location,
  userInfo: state.common.userInfo,
  login: state.common.login,
  productTabIndex: state.product.productTabIndex,
  dittoSaved: state.ditto.dittoSaved,
  fetchLensPackages: state.product.getLensPackages,
  isTryOnSwitch: state.common.isTryOnSwitch,
  dataLocale: state.locale,
  threeSixtyViewStatus: state.product.threeSixtyViewStatus,
  localeInfo: state.common.localeInfo,
  isExchange: state.returnExchange.isExchange,
  platform: state.DTM.platform,
});

function mapDispatchToProps(dispatch) {
  return {
    productApiCall: bindActionCreators(productApiCall, dispatch),
    commonApiCall: bindActionCreators(commonApiCall, dispatch),
    categoryApiCall: bindActionCreators(categoryApiCall, dispatch),
    showGlobalHeaderFooter: bindActionCreators(showGlobalHeaderFooter, dispatch),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Product));
